import { createReducer, on } from "@ngrx/store";

import { jamActions } from "@app/auth/store/actions/jam.actions";
import { JamState } from "@app/models/jam.model";

export const initialJamState: JamState = {
  metadata: {},
};

export const jamReducer = createReducer(
  initialJamState,

  on(jamActions.updateMetadata, (state, { metadata }): JamState => ({
    ...state,
    metadata: {
      ...state.metadata,
      ...metadata,
    },
  })),

  on(jamActions.removeMetadataKey, (state, { key }): JamState => {
    const { [key]: _, ...rest } = state.metadata;

    return {
        ...state,
        metadata: rest as JamState['metadata'],
    };
    }),

  on(jamActions.clearMetadata, (): JamState => ({
    metadata: {},
  })),
);